const public_bucket = process.env.RAZZLE_MOBITO_FRONTEND_S3_PUBLIC_BUCKET;
const public_endpoint = process.env.RAZZLE_MOBITO_FRONTEND_S3_PUBLIC_ENDPOINT;

export const getSampleFileURL = (name) => {
    if (public_endpoint) {
      return `${public_endpoint}/${public_bucket}/public-files/sample-files/${name}`;
    } else {
      return `https://${public_bucket}.s3.amazonaws.com/public-files/sample-files/${name}`
    }
};